import React from 'react'
import { Icon as DownloadIcon } from 'images/download.svg'
import { Icon as ArrowDownIcon } from 'images/utility-icons/arrow-down.svg'
import PropTypes from 'prop-types'
import { Accordion, ExternalLink } from 'components'

const propTypes = {
  showAccordion: PropTypes.bool.isRequired,
  handleToggleAccordion: PropTypes.func.isRequired,
  accordionItems: PropTypes.array.isRequired,
  setExpandedItems: PropTypes.func.isRequired,
  link: PropTypes.string,
}

const defaultProps = {
  link: null,
}

function ParticipantUploadInstructionsSection({
  showAccordion,
  handleToggleAccordion,
  accordionItems,
  setExpandedItems,
  link,
}) {
  return (
    <div className="form-section form-section--new-spreadsheet">
      <h3>File upload instructions</h3>
      <div className="upload-instructions">
        <p>1. Download the participant data spreadsheet.</p>
        <ExternalLink
          className="link-text"
          aria-label="New Participant Data File Spreadsheet"
          link={link}
        >
          Participant data spreadsheet
        </ExternalLink>
        <DownloadIcon aria-hidden="true" />
        <p>2. Complete the template and upload it above. </p>
        <button className="button-text" onClick={handleToggleAccordion}>
          View template instructions
        </button>
        <ArrowDownIcon aria-hidden="true" />
      </div>
      {showAccordion && (
        <Accordion
          items={accordionItems}
          initialItemsExpanded={['instructions']}
          onChange={(itemUuids) => setExpandedItems(itemUuids)}
        />
      )}
    </div>
  )
}
ParticipantUploadInstructionsSection.propTypes = propTypes
ParticipantUploadInstructionsSection.defaultProps = defaultProps

export default ParticipantUploadInstructionsSection
